module.exports = __webpack_public_path__ + "img/new-application-form-graphic@2x.0c53f2f1.png";